/**
 * Il **Contatto** (`.scratch/contatti-lead/spec.md`): un account `cliente`
 * approvato che non ha ancora un Cliente su NTS (`idCliente` assente). Vede
 * catalogo, prezzi, preferiti, carrello e avvisi; il Cliente nasce con il suo
 * primo ordine, e da lì `contatto` torna falso.
 *
 * Le regole stanno qui, in un posto solo: la usano `useContatto()`, il menu
 * dell'Area Clienti, le scorciatoie della Panoramica e la guardia di rotta.
 */

/** Vero per il titolare di un account senza Cliente: lo dice il backend in
 *  `UserOut.contatto`. Un operatore non può esistere senza Cliente. */
export function eContatto(user: { ruolo?: string; contatto?: boolean | null } | null | undefined): boolean {
  return !!user && user.ruolo === 'cliente' && user.contatto === true;
}

/**
 * Le pagine dell'Area Clienti che chiedono un Cliente: le loro API rispondono
 * 404 "Anagrafica cliente non collegata." a un Contatto. Valgono anche per le
 * sotto-rotte (dettaglio ordine, documento, reso).
 */
export const ROTTE_SOLO_CLIENTE: readonly string[] = [
  '/area-clienti/ordini',
  '/area-clienti/documenti',
  '/area-clienti/storico-acquisti',
  '/area-clienti/contabilita',
  '/area-clienti/rma',
  '/area-clienti/indirizzi-spedizione',
  '/area-clienti/operatori',
  // I modelli salvati sono legati al conto (`/api/clienti/me/macchine`).
  '/area-clienti/parco-macchine',
];

/** Etichetta admin di un account approvato senza Cliente sul Gestionale. */
export const ETICHETTA_CONTATTO = 'Contatto · nessun ordine';

/** La rotta (o una sua sotto-rotta) chiede un Cliente. */
export function richiedeCliente(pathname: string): boolean {
  const p = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return ROTTE_SOLO_CLIENTE.some(r => p === r || p.startsWith(`${r}/`));
}
